import { render, staticRenderFns } from "./unrepeatAbleText.vue?vue&type=template&id=40874964&scoped=true"
import script from "./unrepeatAbleText.vue?vue&type=script&lang=js"
export * from "./unrepeatAbleText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40874964",
  null
  
)

export default component.exports